import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    flexDirection: 'column',
    marginTop: theme.spacing(2),
  },
  sizeImg: {
    width: '100%',
    height: '10vh',
    minWidth: '100px',
  },
  content: {
    marginTop: theme.spacing(3),
  },
  field: {
    display: 'flex',
    marginBottom: 16,
    textAlign: 'center',
    width: '100%',
  },
  buttonContainer: {
    display: 'flex',
    alignItems: 'center',
    maxHeight: 72,
  },
}));
